import config from 'config';

export type AiHubEndpointMode = 'new' | 'legacy';

export function getAiHubEndpointMode(): AiHubEndpointMode {
  return 'new';
}

export function setAiHubEndpointMode(_mode: AiHubEndpointMode | 'auto'): void {
  // no-op — legacy AI Hub is retired; the mode is pinned to 'new'
}

const apiGatewayAiHubBaseURL = (): string =>
  `${config.API_SERVICE_ENDPOINT}/ai-hub`;

export function getAiHubBaseURL(): string {
  return apiGatewayAiHubBaseURL();
}

export function isAiHubBaseURL(baseURL: string | undefined | null): boolean {
  if (!baseURL) return false;
  return baseURL === apiGatewayAiHubBaseURL();
}

export function getPublicAiHubBaseURL(): string {
  return config.PUBLIC_API_SERVICE_ENDPOINT;
}
